<img src="assets/images/logo-blablacar.png" width="50" height="50" style="float: right">
TODO <a href="https://support.blablacar.com/hc/en-gb/articles/360014199820--Search-V3-API-Documentation">BlaBlaCar API</a>
<div *ngIf="currentPosition">
    From coordinates: {{currentPosition.latitude}}, {{currentPosition.longitude}}<br>
    To coordinates: {{organizedActivity.position.latitude}}, {{organizedActivity.position.longitude}}<br>
    Start time from..to: {{organizedActivity.startTime}} - DISTANCE * 1M -2..-6H<br>
</div>
<button mat-raised-button color="primary" (click)="offerSeats()">{{'offer_seats'|translate}}</button>
